<template>
	<div class="basis-page-cls" v-loading="loading">
		<section class="basis-cls_table">
			<div class="table">
				<table-pagination
					:data="list"
					:column="column" />
			</div>
		</section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['row'],
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		return {
			column: [
				{ label: '推送文章', prop: 'q' },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 80,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<el-button 
								type="danger"
								size="mini"
								onClick={() => this.handleDelete(scope.row)}>
								删除
							</el-button>
						)
                    }
                }
            ],
			listQuery: {
				projectId: '',
				resourceId: ''
			},
			list: [],
			loading: false,
		}
	},
	async created() {
		await this.getList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.$store.getters.userInfo.brandIdentify;
			this.listQuery.resourceId = this.row.id;
			this.$api.apiPostKnowledgeSelectNewQaListSet(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data;
				this.loading = false;
			});
		},
		handleDelete(row) {
			this.$confirm(`是否删除此 ${row.q}？`,"系统提示",{
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$api.apiPostKnowledgeQAUpdPush({
					projectId: this.userInfo.brandIdentify,
					id: row.id,
					push: 0
				}).then(response => {
					if(response.errcode != 0) return;
					this.getList();
				});
			}).catch(() => {});
		}
	}
}
</script>